import {defineStore} from "pinia";
import * as AboutService from "@/services/about.service";
import {ref} from "vue";


export const useAboutStore = defineStore('about', () => {
    const loading = ref(false);
    const team = ref([]);
    const contactInfo = ref([]);


    async function getTeam() {
        loading.value = true;
        try {
            const response = await AboutService.getTeam();
            if (!response) {
                console.error("Team not found");
                team.value = [];
                return null;
            }
           team.value = response;
            console.log("Team loaded in store:", team.value);
        } catch (error) {
            console.error("Error fetching team:", error);
            team.value = [];
        } finally {
            loading.value = false;
        }
    }

    async function getContactInfo() {
        loading.value = true;
        try {
            const response = await AboutService.getContactInfo();
            if (!response) {
                console.error("Info not found");
                contactInfo.value = [];
                return null;
            }
            contactInfo.value = response;
        } catch (error) {
            console.error("Error fetching contact info:", error);
            contactInfo.value = [];
        } finally {
            loading.value = false;
        }
    }

    return {
        team,
        loading,
        getTeam,
        contactInfo,
        getContactInfo
    };
});